(function(){
  var root=document.getElementById('wa-float');
  if(!root)return;
  var btn=document.getElementById('wa-btn');
  var closeBtn=document.getElementById('wa-close');
  var msgsEl=document.getElementById('wa-msgs');
  var quickEl=document.getElementById('wa-quick');
  var form=document.getElementById('wa-form');
  var input=document.getElementById('wa-input');
  var sendBtn=document.getElementById('wa-send');

  var FN=root.getAttribute('data-fn')||'';
  var ANON=root.getAttribute('data-anon')||'';
  var EMAIL_FN=FN.replace('chat-agent','guardar-correo');
  var WA_ATN='56982638109';

  // Config (temas metaobjetos + opciones WhatsApp + retiro) desde el JSON del liquid
  var CFG={topics:[],wa:[],retiro:[],email:''};
  try{CFG=JSON.parse(document.getElementById('wa-config').textContent)||CFG;}catch(e){}
  var topics=CFG.topics||[];
  var KB=(CFG.conocimiento||[]).filter(Boolean).join('\n\n');   // base de conocimiento editable
  var byKey={}; topics.forEach(function(t){byKey[t.key]=t;});
  function childrenOf(key){return topics.filter(function(t){return t.parent===key;});}
  function topLevel(){return topics.filter(function(t){return !t.parent;});}

  // Acceso seguro a localStorage (algunos navegadores moviles lo bloquean y lanzan error)
  function lsGet(k){try{return localStorage.getItem(k);}catch(e){return null;}}
  function lsSet(k,v){try{localStorage.setItem(k,v);}catch(e){}}

  // Sesion / nombre persistentes
  var sid=lsGet('wa_sid');
  if(!sid){sid='s-'+Date.now().toString(36)+Math.random().toString(36).slice(2,8);lsSet('wa_sid',sid);}
  var nombre=lsGet('wa_name')||'';
  var correo=lsGet('wa_mail')||'';
  var aiMsgs=[];        // contexto para el agente IA
  var awaiting=null;    // 'name' | 'email' | 'comuna' | null
  var started=false;
  var busy=false;
  var timeline=[];        // linea de tiempo de mensajes (para persistir entre paginas)
  var replaying=false;
  var lastShown=[];       // ultimos productos mostrados (con handle) para "agrega el 1"
  var askedEmail=false;   // ya pedimos el correo una vez en esta conversacion
  var userTurns=0;        // cuantas veces el cliente le ha escrito al agente

  // Persistencia de la conversacion en la sesion del navegador (sobrevive cambios de pagina)
  function ssGet(){try{return JSON.parse(sessionStorage.getItem('wa_conv')||'null');}catch(e){return null;}}
  function ssSet(o){try{sessionStorage.setItem('wa_conv',JSON.stringify(o));}catch(e){}}
  function persist(){ if(replaying)return; ssSet({open:root.classList.contains('wa-open'),started:started,nombre:nombre,awaiting:awaiting,aiMsgs:aiMsgs,lastShown:lastShown,askedEmail:askedEmail,timeline:timeline.slice(-60)}); }

  /* ---------- utilidades UI ---------- */
  function esc(s){return (s||'').replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function linkify(s){
    var t=esc(s);
    t=t.replace(/\*\*([^*]+)\*\*/g,'<strong>$1</strong>');
    t=t.replace(/^[\s]*[-*]\s+/gm,'• ');
    t=t.replace(/\n/g,'<br>');
    t=t.replace(/(https?:\/\/[^\s<]+)/g,function(u){return '<a href="'+u+'" target="_blank" rel="noopener">'+u.replace(/^https?:\/\//,'')+'</a>';});
    return t;
  }
  function scrollBottom(){msgsEl.scrollTop=msgsEl.scrollHeight;}
  function addMsg(role,html){
    var d=document.createElement('div');
    d.className='wa-bubble '+(role==='user'?'wa-user':'wa-bot');
    d.innerHTML=html;
    msgsEl.appendChild(d); scrollBottom();
    if(!replaying){ timeline.push({t:'msg',role:(role==='user'?'user':'bot'),html:html}); persist(); }
    return d;
  }
  function botText(text){return addMsg('bot',linkify(text));}
  function typing(){
    var d=document.createElement('div');
    d.className='wa-typing'; d.innerHTML='<span></span><span></span><span></span>';
    msgsEl.appendChild(d); scrollBottom(); return d;
  }
  function addProductos(list){
    if(!list||!list.length)return;
    var top=list.slice(0,3);
    lastShown=top.slice();   // recordamos handle+precio para "agrega el 1"
    var wrap=document.createElement('div'); wrap.className='wa-prods';
    top.forEach(function(p){
      var card=document.createElement('div'); card.className='wa-prod';
      var a=document.createElement('a');
      a.className='wa-prod-link'; a.href=p.url||'#'; a.rel='noopener';
      var img=document.createElement('span'); img.className='wa-prod-img';
      if(p.imagen){img.style.backgroundImage="url('"+p.imagen+"')";}
      var info=document.createElement('span'); info.className='wa-prod-info';
      var tit=document.createElement('span'); tit.className='wa-prod-tit'; tit.textContent=p.titulo||'';
      var pre=document.createElement('span'); pre.className='wa-prod-precio'; pre.textContent=p.precio||'';
      var ver=document.createElement('span'); ver.className='wa-prod-ver'; ver.textContent='Ver producto ›';
      info.appendChild(tit); info.appendChild(pre); info.appendChild(ver);
      a.appendChild(img); a.appendChild(info);
      card.appendChild(a);
      if(p.handle){
        var add=document.createElement('button');
        add.type='button'; add.className='wa-prod-add'; add.textContent='Agregar al carrito 🛒';
        add.addEventListener('click',function(e){e.stopPropagation();addToCart(p.handle,p.titulo||'',add);});
        card.appendChild(add);
      }
      wrap.appendChild(card);
    });
    msgsEl.appendChild(wrap); scrollBottom();
    if(!replaying){ timeline.push({t:'prods',list:top}); persist(); }
  }

  /* ---------- carrito ---------- */
  function bumpCartBadge(n){
    var link=root.querySelector('[data-wa-cart]'); if(!link)return;
    var b=link.querySelector('.wa-cart-badge');
    if(!b){ b=document.createElement('span'); b.className='wa-cart-badge'; link.appendChild(b); }
    var cur=parseInt(b.textContent||'0',10); if(isNaN(cur))cur=0;
    b.textContent=String(cur+(n||1));
  }
  function addToCart(handle,titulo,btn){
    if(!handle)return;
    if(btn){btn.disabled=true; btn.textContent='Agregando…';}
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(prod){
      var v=(prod.variants||[]).filter(function(x){return x.available;})[0]||(prod.variants||[])[0];
      if(!v){throw new Error('sin variante');}
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'content-type':'application/json'},
        body:JSON.stringify({items:[{id:v.id,quantity:1}]})
      }).then(function(r){if(!r.ok){throw new Error('add');}return r.json();});
    }).then(function(){
      bumpCartBadge(1);
      tagCart();
      if(btn){btn.textContent='¡Agregado! ✓';}
      botText('¡Listo! Agregué '+(titulo||'el producto')+' a tu carrito 🛒');
      clearQuick();
      chip('🛒 Ir a pagar','wa-chip-wa',function(){close();window.location.href='/cart';});
      chip('‹ Seguir viendo','wa-chip-ghost',showQuickMini);
    }).catch(function(){
      if(btn){btn.disabled=false; btn.textContent='Agregar al carrito 🛒';}
      botText('Uf, no pude agregarlo automáticamente 😅. Puedes abrir el producto y agregarlo, o escribirnos por WhatsApp: +56 9 8263 8109');
    });
  }
  function clearQuick(){quickEl.innerHTML='';}
  function chip(label,cls,fn){
    var b=document.createElement('button');
    b.type='button'; b.className='wa-chip'+(cls?' '+cls:''); b.textContent=label;
    b.addEventListener('click',function(e){e.stopPropagation();fn();});
    quickEl.appendChild(b); return b;
  }
  function setBusy(v){busy=v; input.disabled=v; sendBtn.disabled=v;}

  /* ---------- menu principal ---------- */
  function quickLabel(text){var d=document.createElement('div');d.className='wa-quick-label';d.textContent=text;quickEl.appendChild(d);}
  function mainMenu(){
    awaiting=null; clearQuick();
    quickLabel('Otros clientes también han preguntado por:');
    topLevel().forEach(function(t){
      chip(((t.icon?t.icon+' ':'')+t.title).trim(),'',function(){onTopic(t.key);});
    });
    quickLabel('Otras formas de comunicarnos:');
    (CFG.wa||[]).forEach(function(o){
      chip('💬 '+o.title,'wa-chip-wa',function(){openWa(o.phone,o.msg);});
    });
    if(CFG.email){chip('✉️ '+CFG.email,'wa-chip-ghost',function(){window.location.href='mailto:'+CFG.email;});}
    chip('▴ Ocultar opciones','wa-chip-ghost',showQuickMini);
    persist();
  }
  // Version discreta: solo un boton para reabrir las opciones (no molesta en celular)
  function showQuickMini(){
    awaiting=null; clearQuick();
    chip('⚡ Opciones rápidas','wa-chip-ghost',mainMenu);
    persist();
  }
  function backChip(){chip('‹ Volver al menú','wa-chip-ghost',mainMenu);}

  function openWa(phone,msg){
    var u='https://wa.me/'+phone; if(msg){u+='?text='+encodeURIComponent(msg);}
    window.open(u,'_blank');
  }

  /* ---------- flujo de temas ---------- */
  function onTopic(key){
    var t=byKey[key]; if(!t)return;
    var k=(key||'').toLowerCase();
    if(k.indexOf('despacho')>-1||k.indexOf('envio')>-1||k.indexOf('envío')>-1){return startDespacho();}
    if(k.indexOf('retiro')>-1||k.indexOf('pickup')>-1||k.indexOf('pick-up')>-1){return startRetiro();}
    // tema normal: mostrar respuesta del metaobjeto
    addMsg('user',esc(((t.icon?t.icon+' ':'')+t.title).trim()));
    if(t.answer){botText(t.answer);}
    var kids=childrenOf(key);
    clearQuick();
    if(kids.length){
      kids.forEach(function(c){chip(((c.icon?c.icon+' ':'')+c.title).trim(),'',function(){onTopic(c.key);});});
      backChip();
    }else{
      if(t.wa){chip('💬 Seguir por WhatsApp','wa-chip-wa',function(){openWa(WA_ATN,t.wa);});}
      backChip();
    }
  }

  /* ---------- despacho por comuna (IA) ---------- */
  function startDespacho(){
    addMsg('user','🚚 Despachos');
    botText('¡Genial! Para calcular tu despacho, cuéntame: ¿a qué comuna necesitas el envío? 🚚');
    awaiting='comuna'; clearQuick(); backChip();
    input.focus();
  }

  /* ---------- retiro en tienda ---------- */
  function startRetiro(){
    addMsg('user','🏬 Retiro en tienda');
    var pts=CFG.retiro||[];
    if(!pts.length){
      botText('Tenemos retiro gratis en tienda 🏬. Escríbenos y coordinamos el punto contigo.');
      clearQuick(); backChip(); return;
    }
    botText('¡Perfecto! Puedes retirar sin costo en cualquiera de nuestros puntos Pick Up 🏬. ¿Cuál te queda mejor?');
    clearQuick();
    pts.forEach(function(p){
      chip('📍 '+p.nombre,'',function(){
        addMsg('user','📍 '+p.nombre);
        botText(p.info+'\n\nRecuerda esperar el correo de "pedido listo" antes de venir 😉');
        clearQuick(); backChip();
      });
    });
    backChip();
  }

  /* ---------- IA ---------- */
  function callAI(userText){
    aiMsgs.push({role:'user',content:userText}); userTurns++;
    if(aiMsgs.length>16){aiMsgs=aiMsgs.slice(-16);}
    var t=typing(); setBusy(true);
    fetch(FN,{
      method:'POST',
      headers:{'content-type':'application/json','apikey':ANON,'authorization':'Bearer '+ANON},
      body:JSON.stringify({sessionId:sid,nombre:nombre,extra:KB,productos_recientes:lastShown,messages:aiMsgs})
    }).then(function(r){return r.json();}).then(function(j){
      t.remove();
      var reply=(j&&j.reply)?j.reply:'Perdón, no logré responder eso. ¿Te ayudo por WhatsApp? +56 9 8263 8109';
      aiMsgs.push({role:'assistant',content:reply});
      botText(reply);
      if(j&&j.productos&&j.productos.length){addProductos(j.productos);}
      if(!quickEl.children.length){showQuickMini();}
      // En algún momento de la conversación (2ª interacción) pedimos el correo, una sola vez
      if(!correo&&!askedEmail&&awaiting===null&&userTurns>=2){askEmail();}
      setBusy(false); input.focus();
    }).catch(function(){
      t.remove();
      botText('Uf, tuve un problema de conexión 😅. Puedes escribirnos por WhatsApp: +56 9 8263 8109');
      setBusy(false);
    });
  }

  /* ---------- envio del formulario ---------- */
  function handleSubmit(text){
    text=(text||'').trim(); if(!text||busy)return;
    if(awaiting==='name'){
      var n=text.replace(/[^\p{L}\p{N} .'-]/gu,'').trim().split(/\s+/)[0]||text;
      var norm=n.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
      var saludos=['hola','ola','holi','holaa','holaaa','buenas','buenos','buenass','hey','hello','hi','ey','ola!','saludos','buendia','wena','wenas'];
      addMsg('user',esc(text));
      if(saludos.indexOf(norm)>-1||n.length<2){
        // El nombre es obligatorio: si respondió un saludo, se lo pedimos de nuevo
        botText('¡Hola! 😊 Cuéntame tu nombre para ayudarte mejor 🙂');
        return; // seguimos en awaiting='name'
      }
      nombre=n.charAt(0).toUpperCase()+n.slice(1);
      lsSet('wa_name',nombre);
      awaiting=null;
      botText('¡Un gusto, '+esc(nombre)+'! 🙌 ¿En qué te puedo ayudar hoy? Elige una opción o escríbeme lo que necesites.');
      mainMenu();
      return;
    }
    if(awaiting==='email'){
      addMsg('user',esc(text));
      awaiting=null;
      var mail=text.trim();
      var skip=/^(no|omitir|saltar|skip|paso|luego|despues|después|nel|no gracias|mejor no|ninguno|ahora no)$/i.test(mail.replace(/[.!¡¿?]/g,''));
      var okMail=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail);
      if(okMail){
        correo=mail; lsSet('wa_mail',correo); saveCorreo();
        botText('¡Gracias, '+esc(nombre||'')+'! 🙌 Anotado. ¿Seguimos?');
        mainMenu();
      }else if(skip){
        botText('¡No hay problema! 😊 ¿En qué más te ayudo?');
        mainMenu();
      }else{
        // No es correo ni "omitir": el cliente siguió con otra consulta -> la respondemos normal
        clearQuick();
        callAI(text);
      }
      return;
    }
    addMsg('user',esc(text));
    if(awaiting==='comuna'){
      awaiting=null; clearQuick();
      callAI('¿Cuál es el plazo y el costo aproximado de despacho a '+text+'?');
      return;
    }
    clearQuick();
    callAI(text);
  }
  // Marca el carrito de Shopify como originado en el chat (dato interno, invisible para el cliente)
  function tagCart(){
    try{
      fetch('/cart/update.js',{
        method:'POST',
        headers:{'content-type':'application/json'},
        body:JSON.stringify({attributes:{'Origen':'Asistente web (chat)','_wa_sid':sid}})
      });
    }catch(e){}
  }
  // Pide el correo una vez, más adelante en la conversación (no bloquea)
  function askEmail(){
    askedEmail=true;
    botText('Por cierto, ¿me dejas tu correo para poder contactarte por cualquier cosa? 📩 (o escribe "omitir" para seguir).');
    awaiting='email'; persist();
  }
  // Guarda el correo del cliente en la base (Supabase) para el CRM
  function saveCorreo(){
    if(!correo)return;
    try{
      fetch(EMAIL_FN,{
        method:'POST',
        headers:{'content-type':'application/json','apikey':ANON,'authorization':'Bearer '+ANON},
        body:JSON.stringify({sessionId:sid,nombre:nombre,correo:correo})
      });
    }catch(e){}
  }
  form.addEventListener('submit',function(e){e.preventDefault();var v=input.value;input.value='';handleSubmit(v);});

  /* ---------- arranque de la conversacion ---------- */
  function startConversation(){
    if(started)return; started=true;
    if(nombre){
      botText('¡Hola de nuevo, '+esc(nombre)+'! 🙌 Qué bueno verte. ¿En qué te ayudo hoy?');
      mainMenu();
    }else{
      botText('¡Hola! 👋 Bienvenido a Mall del Parrillero. Soy tu asistente y estoy para ayudarte con productos, despachos, retiros y más. Para partir, ¿cómo te llamas? 😊');
      awaiting='name'; clearQuick();
    }
    setTimeout(function(){input.focus();},250);
  }

  /* ---------- abrir / cerrar ---------- */
  function open(){root.classList.add('wa-open');startConversation();persist();setTimeout(function(){input.focus();},260);}
  function close(){root.classList.remove('wa-open');persist();}
  function toggle(e){if(e){e.stopPropagation();}root.classList.contains('wa-open')?close():open();}

  btn.addEventListener('click',toggle);
  if(closeBtn)closeBtn.addEventListener('click',function(e){e.stopPropagation();close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){close();}});
  // Clic fuera del chat: se minimiza solo (sin tener que apretar la X)
  document.addEventListener('click',function(e){
    if(root.classList.contains('wa-open')&&!root.contains(e.target)){close();}
  });

  /* -------- restaurar conversacion al navegar a otra pagina -------- */
  (function(){
    var c=ssGet();
    if(!c||!c.started)return;
    replaying=true;
    started=true; nombre=c.nombre||''; aiMsgs=Array.isArray(c.aiMsgs)?c.aiMsgs:[];
    lastShown=Array.isArray(c.lastShown)?c.lastShown:[];
    askedEmail=!!c.askedEmail;
    (c.timeline||[]).forEach(function(it){
      if(it&&it.t==='msg'){addMsg(it.role,it.html);}
      else if(it&&it.t==='prods'){addProductos(it.list);}
    });
    timeline=(c.timeline||[]).slice();
    replaying=false;
    awaiting=c.awaiting||null;
    if(awaiting===null){showQuickMini();}
    else{clearQuick(); if(awaiting==='comuna'){backChip();}}
    if(c.open){root.classList.add('wa-open');}
  })();

  /* ---------- indicador de estado (Lun-Vie 10-17 Chile) ---------- */
  (function(){
    var wrap=root.querySelector('[data-wa-status]'); if(!wrap)return;
    var txt=wrap.querySelector('.wa-status-txt'); var on=false;
    try{
      var f=new Intl.DateTimeFormat('en-US',{timeZone:'America/Santiago',weekday:'short',hour:'2-digit',minute:'2-digit',hour12:false});
      var p={}; f.formatToParts(new Date()).forEach(function(x){p[x.type]=x.value;});
      var wd={Sun:0,Mon:1,Tue:2,Wed:3,Thu:4,Fri:5,Sat:6}[p.weekday];
      var h=parseInt(p.hour,10); if(h===24)h=0;
      var mins=h*60+parseInt(p.minute,10);
      if(wd>=1&&wd<=5){on=mins>=600&&mins<1020;}
    }catch(err){on=false;}
    if(on){wrap.classList.add('is-open');txt.textContent='Estamos atendiendo';}
    else{wrap.classList.remove('is-open');txt.textContent='Te responderemos lo antes posible';}
  })();
})();
